import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import ArrowRight from "../components/svg/arrowRight"
import scrollTo from 'gatsby-plugin-smoothscroll'
import Hero from "../components/hero"
import Seo from "../components/seo"
import {StaticImage} from "gatsby-plugin-image"
import Testimonial from "../components/testimonial"
import Cta from "../components/cta"

const DeferitPage = () => (
    <Layout>
        <Seo 
            title="FinTech Startup Development case study" 
            description="Fintech Startup case study - the web development and app development services completed for this Australian Fintech startup."
        />

        <Hero
            h1="Fintech startup case study"  
            h2="Deferit"
        />

        <section className="bg-purple section-pad-sm">
            <div className="container-lg" id="anchor">
                <div className="row">
                    <StaticImage 
                        src="../images/deferit.jpg"
                        alt="Screens of the Deferit website"
                        formats={["AUTO", "WEBP", "AVIF"]}
                        className="porti-top-img"
                        placeholder="none"
                        backgroundcolor="white"
                        layout="fullWidth"
                        quality="100%"
                    />
                </div>
            </div>
        </section>

        <section className="section-pad-sm">
            <div className="container">
                <div className="row">
                    <div className="porti-wrapper">
                        <div className="cols">
                            <div className="col-26">
                                <div className="sticky-porti-menu">
                                    <button onClick={() => scrollTo('#bg')} className="btn">
                                        Background
                                    </button>
                                    <button onClick={() => scrollTo('#services')} className="btn">
                                        Services
                                    </button>
                                    <button onClick={() => scrollTo('#work')} className="btn">
                                        The work
                                    </button>
                                    <button onClick={() => scrollTo('#testimonial')} className="btn">
                                        Testimonial
                                    </button>
                                    <button onClick={() => scrollTo('#project')} className="btn">
                                        View project
                                    </button>
                                </div>
                            </div>
                            <div className="col-67 long-text">
                                <div id="bg" className="porti-text-section">
                                    <h3>Background</h3>
                                    <p>Deferit is a fintech startup that helps their users defer payment of their bills. Deferit pays the bills upfront and lets the user pay back in 4 payments interest free.</p>
                                </div>
                                <div id="services" className="porti-text-section">
                                    <h4>Services</h4>
                                    <Link to="/react-developers-sydney-canberra/" className="btn btn-lg btn-line">React development</Link>
                                    <Link to="/app-developer-sydney/" className="btn btn-lg btn-line">React Native development</Link>
                                    <Link to="/django-developer-sydney-canberra/" className="btn btn-lg btn-line">Python / Django development</Link>
                                    <Link to="/aws-infrastructure/" className="btn btn-lg btn-line">AWS infrastructure</Link>
                                </div>
                                <div id="work" className="porti-text-section">
                                    <h4>The work</h4>
                                    <p>When we first met Deferit, an Australian Fintech startup, they had already developed a minimum viable product (MVP) and had validated their startup's business model.</p>
                                    <p>They approached Launch Lab to help develop a more professional, robust and scalable version 2 of their product to facilitate growth.</p>
                                    <p>We developed the product using React and Python / Django, moved to a serverless architecture (AWS Lambda), implemented a Saas billing model and have developed a mobile app using React Native.</p>
                                </div>
                                <div id="testimonial" className="porti-text-section">
                                    <h4>Testimonial</h4>
                                    <Testimonial
                                        excerpt="Amazing team"
                                        quote="“Amazing team, really helped our business in the early stages. Shaun and David were great to work with. 10/10. Safe pair of hands and very cost effective.”"
                                        name="Jonty Hirsowitz"
                                        title="CEO, Deferit"
                                    />
                                </div>
                                <div className="porti-text-section">
                                    <StaticImage 
                                        src="../images/lld.jpg"
                                        alt="Photo of the Deferit office"
                                        formats={["AUTO", "WEBP", "AVIF"]}
                                        className="porti-wide-img"
                                        placeholder="none"
                                        backgroundcolor="white"
                                        layout="fullWidth"
                                        quality="100%"
                                    />
                                    <p className="small text-center mt-1">Photo taken at the Deferit office in Sydney shortly after going live.</p>
                                </div>
                                <div id="project" className="porti-text-section">
                                    <h5>View project</h5>
                                    <p>View the Deferit website.</p>
                                    <a href="https://deferit.com.au/" className="btn btn-lg btn-purple">View website</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="bg-purple with-pad">
            <div className="container-lg">
                <div className="row">
                <div className="work-jumbo-wrapper with-radius">
                        <StaticImage 
                            src="../images/portfolio.png"
                            alt="Screengrabs of some of the websites and applications that Launch Lab have designed and developed"
                            formats={["AUTO", "WEBP", "AVIF"]}
                            placeholder="none"
                            backgroundcolor="white"
                            layout="fullWidth"
                            quality="100%"
                            className="with-radius"
                        />
                </div>
                <div className="flex flex-jc">
                    <Link to="/portfolio/" className="btn btn-lg btn-pink">
                    <span className="flex flex-ac">
                        View all projects
                        <ArrowRight />
                    </span>
                    </Link>
                </div>
                </div>
            </div>
        </section>
        
        <Cta 
            text="Get an obligation free web design, web development or startup quote from an experienced local Australian development team."
        />
    </Layout>
)

export default DeferitPage